import React from 'react';
import {
  CalendarToday as CalendarTodayIcon,
  EventNote as EventNoteIcon,
} from '@mui/icons-material';
import ControlToggleGroup from './ControlToggleGroup';

export const TIME_FRAME_TOGGLE_OPTIONS = [
  {
    value: 'annual',
    tooltip: 'Annual Data',
    icon: <CalendarTodayIcon />,
    sublabel: 'FY',
  },
  {
    value: 'quarterly',
    tooltip: 'Quarterly Data',
    icon: <EventNoteIcon />,
    sublabel: 'Q4',
  },
];

function ControlTimeFrameToggle({
  context = 'filterBar',
  value,
  onChange,
  label = 'Time Frame',
  labelWidth = 38,
  buttonWidth = 40,
  ariaLabel = 'Time frame',
}) {
  return (
    <ControlToggleGroup
      context={context}
      value={value}
      onChange={onChange}
      options={TIME_FRAME_TOGGLE_OPTIONS}
      label={label}
      labelWidth={labelWidth}
      buttonWidth={buttonWidth}
      mode="icon"
      ariaLabel={ariaLabel}
    />
  );
}

export default ControlTimeFrameToggle;
